import React, { FC } from 'react';

type Props = {
  className?: string;
};

export const FlagsIcon: FC<Props> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="74"
    height="30"
    viewBox="0 0 74 30"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_8332_85515)">
      <rect
        width="14.7954"
        height="9.76228"
        transform="matrix(-0.900391 -0.435081 0.410796 -0.911727 31.0022 14.7881)"
        fill="white"
      />
      <path d="M21.6353 17.5778L17.6814 8.35131L31.0031 14.7885L21.6353 17.5778Z" fill="white" />
      <rect
        width="14.8731"
        height="9.71305"
        transform="matrix(-0.811506 -0.584345 0.557434 -0.830221 15.7271 6.75635)"
        fill="white"
      />
      <path d="M6.03479 7.85372L3.6547 -1.93497L15.7243 6.75603L6.03479 7.85372Z" fill="white" />
      <rect
        width="14.7006"
        height="9.82176"
        transform="matrix(-0.999972 -0.0075339 0.00702495 -0.999975 81.9299 23.3706)"
        fill="white"
      />
      <path d="M74.534 29.9441L67.2305 23.2592L81.9306 23.37L74.534 29.9441Z" fill="white" />
      <rect
        width="14.7548"
        height="9.78784"
        transform="matrix(-0.944083 -0.329709 0.30964 -0.950854 47.1731 21.0054)"
        fill="white"
      />
      <path d="M38.1616 24.8542L33.2424 16.1397L47.1722 21.0045L38.1616 24.8542Z" fill="white" />
      <rect
        width="14.7047"
        height="9.81916"
        transform="matrix(-0.99577 -0.0918852 0.0857249 -0.996319 64.9309 23.0601)"
        fill="white"
      />
      <path d="M57.0442 28.988L50.2911 21.7089L64.9337 23.06L57.0442 28.988Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_8332_85515">
        <rect width="74" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
